import { makeObservable } from "mobx";
import { BaseCategoryViewStore } from "application/categories/stores";
import { nakiRadioSystemTypes, userDeviceBulkContentType } from "common/constants";
import { homeContentType } from "application/common/content-access";

class StationsViewStore extends BaseCategoryViewStore {
    constructor(rootStore, { routeStore }) {
        super(rootStore);
        this.contentType = userDeviceBulkContentType.stations;
        makeObservable(this);
        this.routeStore = routeStore;

        this.reaction(
            () => this.rootStore.userDeviceStore.selectedDevice,
            (selectedDevice) => {
                const selectedDeviceSystemType = selectedDevice?.device?.systemType?.abrv;
                if (selectedDeviceSystemType === nakiRadioSystemTypes.mobile_restricted || selectedDeviceSystemType === nakiRadioSystemTypes.mobile_handheld ||
                    selectedDeviceSystemType === nakiRadioSystemTypes.mobile_handheld_pink) {
                    this.rootStore.routerStore.goTo("master.application.categories.stories");
                }
            }
        );
    }

    find(params) {
        if (this.selectedDevice) {
            params.deviceId = this.selectedDevice.id;
        }
        return this.routeStore.find(params);
    }

    search(params) {
        params.contentType = homeContentType.station;
        return this.routeStore.search(params);
    }
}

export default StationsViewStore;
